export const cloneConfigModal = {
  close: "Chiudi",
  searchPlaceholder: "Cerca annuncio…",
  clearSearch: "Cancella",
  bar: {
    chooseSource: "Scegli l'annuncio di origine",
    selected: "{count} selezionato | {count} selezionati",
    selectAll: "Seleziona tutti",
    clear: "Cancella",
  },
  list: {
    loading: "Caricamento annunci…",
    empty: "Nessun annuncio corrisponde alla ricerca.",
    unitsBadge: "{count} unità",
  },
  confirm: {
    sourceLabel: "Origine scelta",
    applyToLabel: "Verrà applicato a",
    andItsUnits: "(e le sue {count} unità)",
    andMore: "e altri {count}",
    undoWarning: "Questa azione non può essere annullata.",
  },
  footer: {
    back: "Indietro",
    cancel: "Annulla",
    continue: "Continua",
  },
  preview: {
    unit: "Unità",
    listing: "Annuncio",
    empty: "Non configurato.",
    loading: "Caricamento…",
  },
  confirmTitle: {
    pull: "Conferma prima di importare",
    push: "Rivedi prima di copiare",
  },
  confirmLabel: {
    pulling: "Importazione…",
    copying: "Copia in corso…",
    confirmPull: "Sì, importa le impostazioni",
    confirmPush: "Sì, copia in {count} annuncio | Sì, copia in {count} annunci",
  },
  intro: {
    pullLead: "Stai per importare {noun} dall'annuncio che hai scelto.",
    pullReplace: "Sostituirà ciò che hai qui ora.",
    pullAdd: "Verrà aggiunto a ciò che hai già qui.",
    pushLead: "Stai per copiare {noun} in {count} annuncio. | Stai per copiare {noun} in {count} annunci.",
    pushReplace: "Sostituirà ciò che ha ora{scope}. | Sostituirà ciò che hanno ora{scope}.",
    pushAdd: "Verrà aggiunto a ciò che ha già. | Verrà aggiunto a ciò che hanno già.",
    pushScope: ", comprese le impostazioni di invio",
  },
  attachments: {
    fileFallback: "Allegato",
    titleAlsoCopied: "Vengono copiati anche gli allegati",
    titlePullLose: "Perderai gli allegati che hai ora",
    titlePullGain: "Verranno importati anche i suoi allegati",
    titlePushEmpty: "Gli annunci scelti resteranno senza allegati",
    noteUnknownPull: "Gli allegati dell'annuncio che hai scelto sostituiranno quelli presenti qui, che verranno eliminati.",
    noteUnknownPush: "Gli allegati di questo annuncio sostituiranno quelli degli annunci scelti, che verranno eliminati.",
    notePullReplace: "Verranno eliminati e sostituiti da quelli dell'annuncio che hai scelto.",
    notePullEmpty: "Al momento qui non ci sono allegati, quindi non perdi nulla: verranno importati quelli dell'annuncio scelto.",
    notePushEmpty: "Questo annuncio non ha allegati, quindi quelli dell'annuncio scelto verranno eliminati e resterà senza. | Questo annuncio non ha allegati, quindi quelli degli annunci scelti verranno eliminati e resteranno senza.",
    notePushReplace: "Verranno copiati nell'annuncio scelto e sostituiranno i suoi, che verranno eliminati. | Verranno copiati negli annunci scelti e sostituiranno i loro, che verranno eliminati.",
  },
  toast: {
    loadError: "Impossibile caricare gli annunci",
    pullSuccess: "Impostazioni importate correttamente",
    pushSuccess: "Impostazioni copiate in {count} annuncio | Impostazioni copiate in {count} annunci",
    pullError: "Impossibile importare le impostazioni",
    pushError: "Impossibile copiare le impostazioni",
  },
};
